<div class="status-tag" [class]="statusText">
  {{ statusText }}
</div>
